import { Phone, Instagram, Facebook, MapPin } from "lucide-react";
import { CONTACT_INFO } from "@/lib/constants";

// Slim utility bar that sits above the main nav.
// Adds a corporate touch (contact + socials always visible) without
// disturbing the editorial hero — it is dark and lives at the very top.
export default function UtilityBar() {
  return (
    <div
      data-testid="utility-bar"
      className="hidden md:block fixed top-0 left-0 right-0 z-[60] bg-[#0E0C09] text-[#FDFBF7]/85 border-b border-[#2A2520]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-9 flex items-center justify-between font-mono-accent text-[11px]">
        <div className="flex items-center gap-6">
          <a
            href={`tel:${CONTACT_INFO.phone.replace(/[^0-9+]/g, "")}`}
            data-testid="util-phone"
            className="flex items-center gap-2 hover:text-[#C98A4B] transition-colors"
          >
            <Phone size={11} />
            {CONTACT_INFO.phone}
          </a>
          <span className="flex items-center gap-2 text-[#FDFBF7]/60">
            <MapPin size={11} />
            {CONTACT_INFO.cityState}
          </span>
        </div>
        <div className="flex items-center gap-5">
          <span className="hidden lg:inline text-[#FDFBF7]/55">
            Brunch · Lunch · Dinner · Takeout
          </span>
          <a
            href={CONTACT_INFO.ig_url}
            target="_blank"
            rel="noreferrer"
            data-testid="util-ig"
            aria-label="Instagram"
            className="hover:text-[#C98A4B] transition-colors"
          >
            <Instagram size={13} />
          </a>
          <a
            href={CONTACT_INFO.fb_url}
            target="_blank"
            rel="noreferrer"
            data-testid="util-fb"
            aria-label="Facebook"
            className="hover:text-[#C98A4B] transition-colors"
          >
            <Facebook size={13} />
          </a>
        </div>
      </div>
    </div>
  );
}
